import { useMemo } from 'react'
import { bindActionCreators, Dispatch } from 'redux'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { SearchDescriptor } from 'api/extra/model/search-descriptor'
import { IccSyslogApi } from 'api/api/IccSyslogApi'
import { PaginatedListSyslog } from '../../api/model/PaginatedListSyslog'

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace LogsActions {
  export enum Type {
    LAUNCH_SEARCH = 'LAUNCH_SEARCH',
    LOAD_NEXT_PAGE = 'LOAD_NEXT_PAGE',
  }

  function filterByDescriptorOrTags(descriptor: SearchDescriptor, tags: { tag: string; value: string }[], syslogApi: IccSyslogApi, bookmark: string) {
    const tokenize = (s: string) => (s.includes('|') ? s : `|${s}`)
    if (descriptor) {
      return descriptor.filter.fetch(syslogApi, descriptor.limit, bookmark)
    } else {
      if (tags) {
        const sanitizedTags = tags.find((t) => t.tag === 'date') ? tags : tags.concat({ tag: 'date', value: 'ge2021-01-01' })

        return syslogApi.filter(
          sanitizedTags.filter((x) => x.tag === 'date').map((x) => x.value),
          sanitizedTags.some((x) => x.tag === 'address') ? sanitizedTags.filter((x) => x.tag === 'address').map((x) => tokenize(x.value)) : undefined,
          sanitizedTags.some((x) => x.tag === 'agentIdentifier') ? sanitizedTags.filter((x) => x.tag === 'agentIdentifier').map((x) => tokenize(x.value)) : undefined,
          sanitizedTags.some((x) => x.tag === 'patientIdentifier') ? sanitizedTags.filter((x) => x.tag === 'patientIdentifier').map((x) => tokenize(x.value)) : undefined,
          sanitizedTags.some((x) => x.tag === 'entityIdentifier') ? sanitizedTags.filter((x) => x.tag === 'entityIdentifier').map((x) => tokenize(x.value)) : undefined,
          sanitizedTags.some((x) => x.tag === 'entityType') ? sanitizedTags.filter((x) => x.tag === 'entityType').map((x) => tokenize(x.value)) : undefined,
          sanitizedTags.some((x) => x.tag === 'entityRole') ? sanitizedTags.filter((x) => x.tag === 'entityRole').map((x) => tokenize(x.value)) : undefined,
          sanitizedTags.some((x) => x.tag === 'sourceIdentifier') ? sanitizedTags.filter((x) => x.tag === 'sourceIdentifier').map((x) => tokenize(x.value)) : undefined,
          sanitizedTags.some((x) => x.tag === 'type') ? sanitizedTags.filter((x) => x.tag === 'type').map((x) => tokenize(x.value)) : undefined,
          sanitizedTags.some((x) => x.tag === 'subtype') ? sanitizedTags.filter((x) => x.tag === 'subtype').map((x) => tokenize(x.value)) : undefined,
          sanitizedTags.some((x) => x.tag === 'outcome') ? sanitizedTags.filter((x) => x.tag === 'outcome').map((x) => tokenize(x.value)) : undefined,
          100,
          bookmark,
        )
      } else {
        return Promise.resolve(new PaginatedListSyslog({ rows: [] }))
      }
    }
  }

  export const launchSearch = createAsyncThunk(
    Type.LAUNCH_SEARCH,
    async (context: { api: IccSyslogApi; descriptor?: SearchDescriptor; tags?: { tag: string; value: string }[] }) => {
      return filterByDescriptorOrTags(context.descriptor, context.tags, context.api, undefined)
    },
  )
  export const loadNextPageOfSearchResults = createAsyncThunk(
    Type.LOAD_NEXT_PAGE,
    async (context: { api: IccSyslogApi; descriptor?: SearchDescriptor; tags?: { tag: string; value: string }[]; bookmark?: string }) => {
      return filterByDescriptorOrTags(context.descriptor, context.tags, context.api, context.bookmark)
    },
  )
}

export type LogsActions = Omit<typeof LogsActions, 'Type'>
export const useLogsActions = (dispatch: Dispatch) => {
  const { Type, ...actions } = LogsActions
  return useMemo(() => bindActionCreators(actions as any, dispatch), [dispatch]) as LogsActions
}
